<script>
  import { router, inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';
  import ConfirmDialog from '../../components/ui/ConfirmDialog.svelte';
  import StatusBadge from '../../components/StatusBadge.svelte';

  let { slot, occurrences = [] } = $props();

  let cancelling = $state(null);

  function fmt(t) {
    return new Date(t).toLocaleString();
  }

  function cancel() {
    const occurrence = cancelling;
    cancelling = null;
    router.patch(`/slot_occurrences/${occurrence.id}`, { cancel: true });
  }
</script>

<AppLayout title={slot.name}>
  <div class="flex items-center justify-between mb-6">
    <a use:inertia href="/slots" class="text-sm text-secondary-500 hover:text-primary-600 flex items-center gap-1">
      <Icon icon="mdi:arrow-left" /> Back to slots
    </a>
    <Button href={`/slots/${slot.id}/edit`} variant="ghost"><Icon icon="mdi:pencil-outline" class="mr-1" /> Edit</Button>
  </div>

  <ConfirmDialog
    open={cancelling !== null}
    title="Cancel this occurrence?"
    body="If it's already been sent to outstand, it will be pulled back."
    confirmLabel="Cancel occurrence"
    onconfirm={cancel}
    oncancel={() => { cancelling = null; }}
  />

  <div class="max-w-2xl flex flex-col gap-6">
    <Card>
      <div class="flex items-center justify-between">
        <div>
          <div class="text-secondary-800 font-medium">{slot.name}</div>
          <div class="text-xs text-secondary-500 mt-1">{slot.time_of_day} · {slot.mode}</div>
        </div>
        {#if !slot.active}
          <span class="text-xs text-secondary-400">Paused</span>
        {/if}
      </div>
    </Card>

    <Card title="Upcoming occurrences">
      {#if occurrences.length === 0}
        <div class="text-center py-8">
          <Icon icon="mdi:calendar-blank-outline" class="text-4xl text-secondary-300 mx-auto mb-3" />
          <p class="text-secondary-500">No occurrences generated yet.</p>
        </div>
      {:else}
        <ul class="flex flex-col divide-y divide-secondary-100">
          {#each occurrences as occurrence}
            <li class="py-3 first:pt-0 last:pb-0 flex items-start justify-between gap-3">
              <div class="min-w-0">
                <div class="text-sm text-secondary-700">{fmt(occurrence.occurs_at)}</div>
                {#if occurrence.post}
                  <div class="text-xs text-secondary-500 mt-1 truncate">{occurrence.post.body}</div>
                {:else}
                  <div class="text-xs text-secondary-400 mt-1">Not filled yet</div>
                {/if}
              </div>
              <div class="flex items-center gap-2 shrink-0">
                <StatusBadge status={occurrence.status} />
                {#if occurrence.status !== 'cancelled'}
                  <button
                    onclick={() => { cancelling = occurrence; }}
                    aria-label="Cancel occurrence"
                    class="p-1.5 rounded-lg text-secondary-500 hover:bg-red-50 hover:text-red-700"
                  >
                    <Icon icon="mdi:close" />
                  </button>
                {/if}
              </div>
            </li>
          {/each}
        </ul>
      {/if}
    </Card>
  </div>
</AppLayout>
